import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'universal-cookie';

import Source from '../../../components/Review/components/Source';
import Target from '../../../components/Review/components/Target';
import Header from '../../../components/Header/components/Header';
import Footer from '../../../components/Footer/components/Footer';
import Modal from '../../../components/Modal/components/Modal';
import ScoreModal from '../../../components/Modal/components/Score';
import Overlay from '../../../components/Overlay/components/Overlay';
import ReviewService from '../../../services/Review';
import ReviewerLockService from '../../../services/ReviewerLock';
import { isBlank } from '../../../lib/helpers';

const CHECK_TYPE = {
  rejected_job_review: 3,
};

const START_TIME_COOKIE_PREFIX = 'review_start_time';
const START_TIME_AGE = 86400 * 15;

const LOCK_REVIEWER_FREQUENCY = 120000;
const LOCK_REVIEWER_ERR_DISPLAY_TIME = 30000;

class Check extends Component {
  constructor(props) {
    super(props);
    this.state = {
      review: {},
      highlightRequired: false,
      score: null,
      reviewStartTime: null,
      isSubmitting: false,
    };
    this.service = new ReviewService();
    this.reviewerLockService = new ReviewerLockService();

    this.handleCommentChange = this.handleCommentChange.bind(this);
    this.handleReadabilityChange = this.handleReadabilityChange.bind(this);
    this.handleReviewComplete = this.handleReviewComplete.bind(this);
    this.handleCancelReview = this.handleCancelReview.bind(this);
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.handleAnnotationChange = this.handleAnnotationChange.bind(this);
    this.errorHandler = this.errorHandler.bind(this);
    this.setReviewStartTime = this.setReviewStartTime.bind(this);
    this.getReviewStartCookieName = this.getReviewStartCookieName.bind(this);

    this.setReviewStartTime();

    this.lockReviewerIntervalID = null;
  }

  componentDidMount() {
    this.ReviewObject();
  }

  setReviewStartTime() {
    const cookies = new Cookies();
    const key = this.getReviewStartCookieName();
    const reviewStartTime = cookies.get(key);

    if (!reviewStartTime) {
      this.service.getCurrentTime().then(
        data => {
          cookies.set(key, data.current_time, { maxAge: START_TIME_AGE });
          this.state.reviewStartTime = data.current_time;
        },
      ).catch(this.errorHandler.bind(this));
    } else {
      this.state.reviewStartTime = reviewStartTime;
    }
  }

  getReviewStartCookieName() {
    const { match: { params: { uuid } } } = this.props;
    return `${START_TIME_COOKIE_PREFIX}-${uuid}`;
  }

  ReviewObject() {
    const { match: { params: { uuid } } } = this.props;
    this.refs.overlay.show(true);
    this.service.fetch(uuid).then(
      review => {
        this.setState({ review });
        this.startLockReviewer();

        this.refs.overlay.hide();
        this.refs.target.startAnnotator(uuid, review.editable, review.gocheck_version);
      },
    ).catch(
      e => {
        if (e.status === 401) {
          const loginURL = e.getResponseHeader('Location');
          const url = `${loginURL}?referral=${window.location.href}`;
          window.location.replace(url);
          return;
        }
        this.errorHandler(e);
      },
    );
  }

  startLockReviewer() {
    this.lockReviewer();
    this.lockReviewerIntervalID = setInterval(() => this.lockReviewer(), LOCK_REVIEWER_FREQUENCY);
  }

  lockReviewer() {
    const { review } = this.state;
    this.reviewerLockService.create(review.uuid).catch(e => {
      // Ignore if just forbidden to allow admins still
      // to view the page but without locking the review
      clearInterval(this.lockReviewerIntervalID);
      if (e.status !== 403) {
        this.errorHandler(e);
        setTimeout(() => window.history.back(), LOCK_REVIEWER_ERR_DISPLAY_TIME);
      }
    });
  }

  handleCommentChange(newComment) {
    const { review } = this.state;
    this.setState({
      review: {
        ...review,
        comment: newComment,
      },
    });
  }

  handleReadabilityChange(newReadabilityOption) {
    const { review } = this.state;
    this.setState({
      review: {
        ...review,
        readability: parseInt(newReadabilityOption, 10),
      },
      highlightRequired: false,
    });
  }

  handleReviewComplete() {
    const { review: { uuid, readability } } = this.state;
    if (readability === null) {
      this.setState({
        highlightRequired: true,
      });
      return;
    }
    this.refs.overlay.show(true);
    this.service.getScore(uuid).then(
      data => {
        this.refs.overlay.toBack();
        this.refs.scoreModal.showModal(data.score);
      },
    ).catch(this.errorHandler.bind(this));
  }

  async handleAnnotationChange() {
    const { review: { uuid } } = this.state;
    this.setState({
      score: null,
    });
    try {
      const data = await this.service.getScore(uuid);
      this.setState({
        score: data.score.toFixed(2),
      });
    } catch (e) {
      this.errorHandler(e);
    }
  }

  handleCancelReview() {
    this.refs.overlay.hide();
    this.refs.scoreModal.hideModal();
  }

  errorHandler(e) {
    let response;
    try {
      response = JSON.parse(e.responseText);
    } catch (ex) {
      response = {
        title: 'Error',
        description: 'Unexpected error occurred',
      };
    }
    this.refs.errorModal.showModal(response.title, response.description);
    this.refs.overlay.hide();
  }

  handleOnSubmit() {
    const { isSubmitting } = this.state;

    if (isSubmitting) {
      return;
    }
    this.setState({ isSubmitting: true });
    let comment;
    let readability;
    const {
      review: {
        uuid,
        type,
        readability: readabilityState,
        comment: commentState,
        links: {
          admin_job: { href: adminJobHref },
          admin_check_list: { href: adminCheckHref },
        },
      },
      reviewStartTime,
    } = this.state;

    if (readabilityState !== null && readabilityState !== undefined) {
      readability = readabilityState;
    }

    if (!isBlank(commentState)) {
      comment = commentState;
    }

    this.refs.overlay.toFront();
    this.refs.overlay.show(true);
    this.service.submit(uuid, comment, readability, true, reviewStartTime)
      .then(() => {
        let url = adminCheckHref;
        if (type === CHECK_TYPE.rejected_job_review) {
          url = adminJobHref;
        }

        const cookies = new Cookies();
        const key = this.getReviewStartCookieName();
        cookies.remove(key);

        window.location.replace(url);
      })
      .catch(this.errorHandler.bind(this))
      .finally(() => {
        this.setState({ isSubmitting: false });
      });
  }

  render() {
    const {
      review,
      annotatorUrl,
      highlightRequired,
      score,
    } = this.state;
    const { comment, editable, type } = review;
    return (
      <>
        <Header review={review} score={score} />
        <div id="work_content" className="flex-row content">
          <Source review={review} />
          <Target
            ref="target"
            review={review}
            annotatorUrl={annotatorUrl}
            onAnnotationChange={this.handleAnnotationChange}
          />
        </div>
        <Footer
          comment={comment}
          editable={editable}
          review={review}
          onCommentChange={this.handleCommentChange}
          onReviewSubmit={this.handleReviewComplete}
          onReadabilityChange={this.handleReadabilityChange}
          highlightRequired={highlightRequired}
        />

        <Modal ref="errorModal" title="Title" description="Description" />
        <ScoreModal
          ref="scoreModal"
          rejected={type === CHECK_TYPE.rejected_job_review}
          onSubmitFeedback={this.handleOnSubmit}
          onCancelFeedback={this.handleCancelReview}
        />
        <Overlay ref="overlay" />
      </>
    );
  }
}

Check.propTypes = {
  match: PropTypes.object.isRequired,
};

export default Check;
